// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__3R26D","progress":"Skill_progress__27mHo","title":"Skill_title__n0sFo","bar":"Skill_bar__2yATD"};